import { useCallback, useSyncExternalStore } from 'react';

/** Geometry of the docked detail rail (contacts and similar pages), persisted per device like the sidebar. */
export const RAIL_MIN = 360;
export const RAIL_MAX = 800;
export const RAIL_DEFAULT = 460;

const KEY = 'crewline-rail';
const listeners = new Set<() => void>();
let width: number | null = null;

const clamp = (w: number) => Math.round(Math.min(RAIL_MAX, Math.max(RAIL_MIN, w)));

function read(): number {
  if (width !== null) return width;
  try {
    const raw = localStorage.getItem(KEY);
    const n = raw ? Number(raw) : NaN;
    width = Number.isFinite(n) ? clamp(n) : RAIL_DEFAULT;
  } catch {
    width = RAIL_DEFAULT;
  }
  return width;
}

function write(next: number): void {
  width = clamp(next);
  try {
    localStorage.setItem(KEY, String(width));
  } catch {
    /* ignore */
  }
  for (const l of listeners) l();
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function useRailWidth() {
  const w = useSyncExternalStore(subscribe, read, () => RAIL_DEFAULT);
  const setWidth = useCallback((n: number) => write(n), []);
  const reset = useCallback(() => write(RAIL_DEFAULT), []);
  return { width: w, setWidth, reset };
}
